export const SERVICES_GROUP = {
	INTERNAL: 'internal',
	EXTERNAL: 'external'
};

export const SERVICES_TYPES = {
	UNLIMITED_KM: 'unlimitedKm',
	INSURANCE: 'insurance',
	DROP_CITY: 'dropCity',
	DELIVERY: 'delivery',
	DRIVER: 'driver',
	TAMM: 'tamm'
};
